
import { defineComponent } from 'vue';
import { getSpecificPlayer } from '@/api/api'
import { UseRequest } from '@/utils/useRequest'
import { getSpecificPlayerParamType } from '@/types/api'

import ProgressBar from "@/components/ProgressBar.vue";
import Error from "@/components/Error.vue";

export default defineComponent({
  components: {
    ProgressBar,
    Error
  },
  props: {
    playerId: String
  },
  setup(props) {

    const specificPlayer = new UseRequest(getSpecificPlayer)
    specificPlayer.createRequest<getSpecificPlayerParamType>({
      id: props.playerId!
    })

    return {
      specificPlayer
    }
  }
});
